import { useEffect, useState } from 'react';
import { getCalendarioDetalle } from '../services/jornadasService';
import { getParticipantesReal } from '../services/participantesService';

// Ambos endpoints son públicos (no hacen falta permisos ni sesión), así que
// esto sirve igual para /jornadas (público) que para /dashboard/jornadas.
// El roster (quién está inscrito en cada participante) hace falta para
// "mis partidos": la alineación real de un partido futuro está vacía, pero
// el roster ya dice de qué equipo/jugador es cada participante.
export function useCalendarioDetalle(temporada) {
  const [partidos, setPartidos] = useState([]);
  const [rosterPorParticipante, setRosterPorParticipante] = useState({});
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!temporada) return;
    setCargando(true);
    setError(null);
    Promise.all([getCalendarioDetalle(temporada), getParticipantesReal(temporada)])
      .then(([partidosDatos, participantesDatos]) => {
        setPartidos(partidosDatos);
        setRosterPorParticipante(
          Object.fromEntries(participantesDatos.map((p) => [p.participante_id, p.jugadores]))
        );
      })
      .catch(() => setError('No se pudieron cargar las jornadas. ¿Está el servidor en marcha?'))
      .finally(() => setCargando(false));
  }, [temporada]);

  return { partidos, rosterPorParticipante, cargando, error };
}
